import React, { Component } from "react";
import { get as _get, isEqual as _isEqual, isEmpty as _isEmpty } from "lodash";
import { Accordion, Card } from "react-bootstrap";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import Helmet from "react-helmet";

import { showAlertMessage } from "../../resusableComponents/common/formElements";

import { withRouter } from "../../resusableComponents/hoc/withRouter";
import DeleteSearchButton from "../../resusableComponents/common/dataSearchTable/components/DeleteSearchButton";
import ExportSearchButton from "../../resusableComponents/common/dataSearchTable/components/ExportSearchButton";
import DataSearchTable from "../../resusableComponents/common/dataSearchTable/components/DataSearchTable";
import EnrichButton from "../../resusableComponents/common/dataSearchTable/components/EnrichButton";

import { getSearchData } from "../../redux/services/dataSearch";

import { updatePageLevelLoadingState } from "../../redux/actions/application";
import { thousandSeparator } from "../../helpers/utils";

class SavedDataSearch extends Component {

  constructor(props) {
    super(props);

    this.defaultSearchDataPayload = {
      page_no: 1,
      page_size: 100
    };

    this.state = {
      defaultSearchDataPayload: { ...this.defaultSearchDataPayload },
      selectedJobSeniority: [],
      selectedIndustry: [],
      selectedRegionCountry: [],
      selectedCompanySize: [],
      selectedRevenue: [],
      selectedDepartment: [],
      searchData: {},
      fileUploaded: false,
      uploadedFileName: "",
      uploadedFileURL: "",
      uploadedTalContactIds: [],
      selectedAllIds: false,
      selectedIds: [],
      refreshChartAndTable: false,
      activeRequestCount: 0,
      savedSearchId: _get(this.props, "params.id", 0)
    };
  }

  componentDidMount() {
    const { savedSearchId } = this.state;

    if (!savedSearchId) {
      showAlertMessage("Oops! You have entered wrong URL");

      setTimeout(() => {
        window.location.href = "/";
      }, 10000);
    }

    this._fetchSearchData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (
        !_isEqual(prevState.defaultSearchDataPayload, this.state.defaultSearchDataPayload) &&
        !_isEqual(_get(prevState, "defaultSearchDataPayload.page_no", 1), _get(this.state, "defaultSearchDataPayload.page_no", 1))
      ) || (
        !_isEqual(prevState.refreshChartAndTable, this.state.refreshChartAndTable) && (_get(this.state, "refreshChartAndTable", false) === true)
      )
    ) {
      this._fetchSearchData();
    }
  }

  _incrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = (_get(prevState, "activeRequestCount", 0) + 1);
      if (nextCount === 1 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(true); }
      return { activeRequestCount: nextCount };
    });
  }

  _decrementLoader = () => {
    const { updatePageLevelLoadingState } = this.props;
    this.setState((prevState) => {
      const nextCount = Math.max(0, _get(prevState, "activeRequestCount", 0) - 1);
      if (nextCount === 0 && typeof updatePageLevelLoadingState === "function") { updatePageLevelLoadingState(false); }
      return { activeRequestCount: nextCount };
    });
  }

  _handleResetFilters = () => {
    this.setState({
      defaultSearchDataPayload: { ...this.defaultSearchDataPayload },
      selectedJobSeniority: [],
      selectedIndustry: [],
      selectedRegionCountry: [],
      selectedCompanySize: [],
      selectedRevenue: [],
      selectedDepartment: [],
      fileUploaded: false,
      uploadedFileName: "",
      uploadedFileURL: "",
      uploadedTalContactIds: [],
      selectedAllIds: false,
      savedSearchId: null,
      selectedIds: [],
      refreshChartAndTable: true
    });
  }

  _fetchSearchData = async () => {
    const { defaultSearchDataPayload, savedSearchId } = this.state;

    try {
      this._incrementLoader();

      const payload = {
        ...defaultSearchDataPayload,
        job_title: [],
        job_seniority: [],
        country: [],
        company_size: [],
        revenue: [],
        department: [],
        industry: [],
        tal_contact_ids: [],
        search_id: (savedSearchId || null)
      };

      const response = await getSearchData(payload);

      if ((response.flag || false) === true) {
        this.setState({ searchData: _get(response, "data", {}), refreshChartAndTable: false });
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while fetching search result data."));
      }

    } catch (error) {
      showAlertMessage(_get(error, "message", "Something went wrong while fetching search result data."));

    } finally {
      this._decrementLoader();
    }
  }

  handlePaginationChange = (pageNo) => {
    const { defaultSearchDataPayload } = this.state;

    this.setState({ defaultSearchDataPayload: { ...defaultSearchDataPayload, page_no: pageNo } });
  }

  _renderSearchFilters = () => {
    const { searchData } = this.state;
    let searchFilterJson = _get(searchData, "search_name[0].search_filter_json", "");
    let parsedFilters = {};

    if (searchFilterJson) {
      try {
        let parsed = searchFilterJson;
        while (typeof parsed === "string") {
          parsed = JSON.parse(parsed);
        }
        parsedFilters = parsed || {};
      } catch (e) {
        console.error("Error parsing search_filter_json", e);
      }
    }

    let validFilters = [];
    if (!_isEmpty(parsedFilters)) {
      Object.keys(parsedFilters).forEach((key) => {
        let value = parsedFilters[key];
        if (Array.isArray(value)) {
          value = value.join(", ");
        } else if (typeof value === "object" && value !== null) {
          try {
            value = JSON.stringify(value);
          } catch (e) {
            value = "";
          }
        }
        if (value && String(value).trim() !== "") {
          validFilters.push({ key, value });
        }
      });
    }

    if (validFilters.length === 0) return null;

    return (
      <div className="row gy-4 mt-0 mb-4">
        <div className="col-lg-12">
          <Accordion className="accordion" alwaysOpen>
            <Card>
              <Accordion.Item eventKey="accordion-0">
                <Accordion.Button>
                  <span className="fw-semibold text-capitalize text-black-2b">
                    <FormattedMessage id="data_search.applied_search_filters" defaultMessage="Applied Search Filters" />
                  </span>
                </Accordion.Button>
                <Accordion.Body>
                  <div className="row gy-3">
                    {validFilters.map((filterObj, index) => {
                      return (
                        <div className="col-lg-12" key={index}>
                          <div>
                            <strong className="text-capitalize">{String(filterObj.key).replace(/_/g, ' ')}</strong>: {String(filterObj.value)}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Card>
          </Accordion>
        </div>
      </div>
    );
  }

  _renderTableData = () => {
    const { searchData, savedSearchId, selectedAllIds, selectedIds, selectedJobSeniority, selectedIndustry, selectedRegionCountry, selectedCompanySize, selectedRevenue, selectedDepartment, uploadedTalContactIds, defaultSearchDataPayload } = this.state;

    return (
      <>
        <div className="row gy-4 mt-0">
          <div className="col-lg-12">
            <div className="card shadow-none">
              <div className="card-body">
                <div className="d-flex flex-column flex-sm-row align-items-stretch justify-content-between flex-wrap gap-2 mb-3">
                  <div className="d-flex align-items-center justify-content-center flex-grow-1">
                    <h5>
                      <FormattedMessage id="data_search.table.showing_records" defaultMessage="Showing Records: {totalRecords}" values={{ totalRecords: thousandSeparator(_get(searchData, "page_info[0].total_records", 0)) }} />
                    </h5>
                  </div>
                  <div className="d-flex flex-grow-1 flex-sm-grow-0">
                    <ExportSearchButton
                      source="history"
                      selectedAllIds={(selectedAllIds || false)}
                      selectedIds={(selectedIds || [])}
                      selectedJobSeniority={(selectedJobSeniority || [])}
                      selectedIndustry={(selectedIndustry || [])}
                      selectedRegionCountry={(selectedRegionCountry || [])}
                      selectedCompanySize={(selectedCompanySize || [])}
                      selectedRevenue={(selectedRevenue || [])}
                      selectedDepartment={(selectedDepartment || [])}
                      uploadedTalContactIds={(uploadedTalContactIds || [])}
                      savedSearchId={(savedSearchId || null)}
                    />
                  </div>
                  <div className="d-flex flex-grow-1 flex-sm-grow-0">
                    <DeleteSearchButton
                      source="history"
                      selectedAllIds={(selectedAllIds || false)}
                      selectedIds={(selectedIds || [])}
                      selectedJobSeniority={(selectedJobSeniority || [])}
                      selectedIndustry={(selectedIndustry || [])}
                      selectedRegionCountry={(selectedRegionCountry || [])}
                      selectedCompanySize={(selectedCompanySize || [])}
                      selectedRevenue={(selectedRevenue || [])}
                      selectedDepartment={(selectedDepartment || [])}
                      uploadedTalContactIds={(uploadedTalContactIds || [])}
                      savedSearchId={(savedSearchId || null)}
                      setState={(args) => this.setState(args)}
                    />
                  </div>
                  <div className="d-flex flex-grow-1 flex-sm-grow-0">
                    <EnrichButton
                      savedSearchId={(savedSearchId || null)}
                      selectedIds={(selectedIds || [])}
                      selectedAllIds={(selectedAllIds || false)}
                    />
                  </div>
                </div>
                <DataSearchTable
                  searchData={(searchData || [])}
                  defaultSearchDataPayload={(defaultSearchDataPayload || {})}
                  onPageChange={(args) => this.handlePaginationChange(args)}
                  onSelectionChange={(selectedIds, selectedAllIds) => this.setState({ selectedIds, selectedAllIds })}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  render() {
    const { intl } = this.props;
    const { searchData } = this.state;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage({ id: "olympus.saved_search", defaultMessage: "Saved Search: Olympus" })}
          </title>
        </Helmet>

        <div className="content-wrapper">
          <div className="container-fluid flex-grow-1 px-6 py-6">
            <div className="row gy-2">
              <div className="col-lg-12">
                <h1 className="heading-04 fw-semibold text-dark-35 text-uppercase">
                  {_get(searchData, "search_name[0].search_name", "")}
                </h1>
              </div>
            </div>
            {!_isEmpty(_get(searchData, "search_name[0].search_filter_json", "")) && this._renderSearchFilters()}
            {this._renderTableData()}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  allowedUploadFiles: _get(state, "application.constants.allowedUploadFiles", ""),
  allowedUploadFilesLabel: _get(state, "application.constants.allowedUploadFilesLabel", ""),
});

const mapDispatchToProps = (dispatch) => ({
  updatePageLevelLoadingState: (data) => dispatch(updatePageLevelLoadingState(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(injectIntl(SavedDataSearch)));
